import { render, staticRenderFns } from "./NewTransfer.vue?vue&type=template&id=5326b46c"
import script from "./NewTransfer.vue?vue&type=script&lang=js"
export * from "./NewTransfer.vue?vue&type=script&lang=js"
import style0 from "./NewTransfer.vue?vue&type=style&index=0&id=5326b46c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports